import { render } from "./FacecareTermsOfUseView.vue?vue&type=template&id=a21b392e&scoped=true"
import script from "./FacecareTermsOfUseView.vue?vue&type=script&lang=js"
export * from "./FacecareTermsOfUseView.vue?vue&type=script&lang=js"

import "./FacecareTermsOfUseView.vue?vue&type=style&index=0&id=a21b392e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21b392e"]])

export default __exports__